import { useEffect } from 'react';

const SUFFIX = ' · T3 Tick3ting';

export function useDocumentTitle(title: string | null | undefined): void {
  useEffect(() => {
    const original = document.title;
    if (title) document.title = `${title}${SUFFIX}`;
    return () => {
      document.title = original;
    };
  }, [title]);
}
